/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {Service} from '../../common/service.class';
import {UserModelService} from '../../common/user-model.service';
import {ActivityLogs} from './activity-logs.model';

@Injectable()
export class ActivityLogsService extends UserModelService<ActivityLogs> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'activityLogs', ActivityLogs);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/activity-logs/activity-logs.service.ts